import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    whiteSpace: 'nowrap',

    '& > :not(:last-child)': {
      marginRight: '-10px'
    }
  }
}))

export default useStyles
